import React from "react";
import { useLang } from "../../context/LanguageContext";
import { Languages } from "lucide-react";

export const LanguageSwitcher = () => {
  const { lang, setLang } = useLang();

  return (
    <div
      className="inline-flex items-center gap-1 rounded-full border border-emerald-900/15 bg-white/70 p-1 shadow-sm backdrop-blur-sm"
      role="group"
      aria-label="Language"
    >
      <Languages className="ml-2 h-3.5 w-3.5 text-emerald-900/60" />
      <button
        type="button"
        data-testid="lang-switch-en"
        onClick={() => setLang("en")}
        className={`rounded-full px-3 py-1 text-xs font-semibold transition-colors ${
          lang === "en"
            ? "bg-emerald-900 text-white"
            : "text-emerald-900/70 hover:bg-emerald-900/10 hover:text-emerald-900"
        }`}
      >
        EN
      </button>
      <button
        type="button"
        data-testid="lang-switch-bn"
        onClick={() => setLang("bn")}
        className={`rounded-full px-3 py-1 text-xs font-semibold transition-colors ${
          lang === "bn"
            ? "bg-emerald-900 text-white"
            : "text-emerald-900/70 hover:bg-emerald-900/10 hover:text-emerald-900"
        }`}
      >
        বাংলা
      </button>
    </div>
  );
};
